import { render, staticRenderFns } from "./LabOfflineDocxPanel.vue?vue&type=template&id=2e7c0a51&scoped=true"
import script from "./LabOfflineDocxPanel.vue?vue&type=script&lang=js"
export * from "./LabOfflineDocxPanel.vue?vue&type=script&lang=js"
import style0 from "./LabOfflineDocxPanel.vue?vue&type=style&index=0&id=2e7c0a51&prod&scoped=true&lang=css"
import style1 from "./LabOfflineDocxPanel.vue?vue&type=style&index=1&id=2e7c0a51&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c0a51",
  null
  
)

export default component.exports